
import { shuffleArray } from "~/utils/utils";
export default {
  props: {
    apiEndpoint: {
      type: String,
      required: true
    },
    initialPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    videoId: {
      type: Number,
      default: 0
    },
    isShuffle: {
      type: Boolean,
      default: false
    },
    initialItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      endOfList: false,
      currentPage: this.initialPage,
      items: [...this.initialItems]
    };
  },
  methods: {
    async loadMore() {
      if (this.loading || this.endOfList) return;
      this.loading = true;
      try {
        let params = {
          site_id: process.env.SITE_ID,
          page: this.currentPage,
          size: this.pageSize
        };
        if (this.videoId !== 0) {
          params.exclude_series_video_id = this.videoId;
        }
        const response = await this.$axios.$get(this.apiEndpoint, { params });
        const newData = response.list;
        /* 数组乱序 */
        this.items = this.items.concat(this.isShuffle ? shuffleArray(newData) : newData);
        if (newData.length === 0 || newData.length < this.pageSize) {
          this.endOfList = true;
        }
        this.currentPage++;
      } catch (error) {
        console.error("Failed to load more data:", error);
      } finally {
        this.loading = false;
      }
    }
  }
};
